import Context from "../../context/Context";
import FieldNames from "../datasets/FieldNames";
import * as aiimUtil from "./aiimUtil";

export function supportsMeetingRooms() {
  if (!Context.instance.uiMode.isKiosk && !Context.instance.user.isAnonymous()) {
    const configuration = Context.getInstance().configuration;
    const configurables = configuration.extractConfigurables();
    if(configurables && configurables.workspaceReservation && configurables.workspaceReservation.enabled) {
      const workspaceReservation = configurables.workspaceReservation;
      const reservationType = workspaceReservation.reservationType;
      
      if(reservationType === "office365") return false;
      if(reservationType === "esri" && !workspaceReservation.enableMeetingRooms) return false;

      const rs = Context.instance.aiim.datasets.minimumReservationSchema;
      const units = Context.instance.aiim.datasets.units;
      const rmfld = units && units.layer2D && 
                          aiimUtil.findField(units.layer2D.fields, FieldNames.AREA_ID) &&
                          aiimUtil.findField(units.layer2D.fields,FieldNames.RESERVATION_METHOD);
      return rs && !!rmfld;

    }
  }
  return false;
}
